import { Layout } from "components2";
import {
  BackButton2,
  InputText,
  NextButton2,
  Radio,
  Seperator,
  Tooltip
} from "components2/CommonUI";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { O2FORM, O2APPOINTMENT_ENTRY, O2APPOINTMENT_INFO, O2IDENTITY, O2WELCOME_BACK } from "../constants/route";
import { hasAppointment, verifyCaptcha } from "../services/api-service2";
import { clearIdTypeChoose, } from "../redux/xAppointment";
import { useSelector, useDispatch, batch } from "react-redux";
import { ID_TYPE } from "constants/o2Appointment";
import { isValidPassport, safeVal, isValidNric } from "utils/common2";
import {  nextIdentity, updateHasAppt, updateIdType, updateNricFin, updatePassport,  } from "redux/o2Appointment";
import { useAdobeDigitalData } from "hooks";
// import ReCAPTCHA from "react-google-recaptcha";

// const from = { state : {from: O2IDENTITY}};

export default function O2Identity() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [nricFinError, setNricFinError] = useState(null);
  const [passportError, setPassportError] = useState(null);
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const { idType, nricFin: nrcFinFromStore, passport: passportFromStore } = useSelector((state) => state.o2Appointment);
  // const [idType, setIdType] = useState(idTypeFromStore || ID_TYPE.NRIC_FIN);
  const { nric: loginNric } = useSelector((state) => state.appointment);
  const [loading, setLoading] = useState(false);
  const [nricFin, setNricFin] = useState(nrcFinFromStore || "");
  const [passport, setPassport] = useState(passportFromStore || "");
  // const [captchaVerified, setCaptchaVerified] = useState(false);

  useAdobeDigitalData({name: "IDENTITY", path:"/identity"});

  // onload
  useEffect(()=>{
    dispatch(clearIdTypeChoose());
  }, []);

  // on-login // onload
  useEffect(() => {
    if(isLogin && loginNric) {
      hasAppointment(loginNric).then(hasAppt=>{
        console.log('hasAppt', hasAppt);
        // dispatch(nextIdentity({ idType: ID_TYPE.NRIC_FIN, nricFin: nric, passport: null }));
        if(hasAppt) {
          navigate(O2APPOINTMENT_INFO);
          return;
        } else {
          navigate(O2APPOINTMENT_ENTRY);
          return;
        }
      });
    }
  }, [isLogin, loginNric]);

  const clkBack = () => {
    navigate(O2FORM);
  };

  const validateNricFin= (hasTouched) => {
    if(!nricFin && hasTouched) {
      dispatch(updateNricFin(null));
      setNricFinError("This field is mandatory.");
      return false;
    }

    if(nricFin && !isValidNric(nricFin.trim())) {
      setNricFinError("Enter a valid NRIC number (e.g. S1234567A) or FIN number (e.g. F1234567A).");
      return false;
    } 

    // Timeout is to delay rendering if there is no error, 
    // which is to let click event on the Next button to be triggered first.
    setTimeout(()=>setNricFinError(null), 100);
    return true
    
  }

  const validatePassport = (hasTouched) => {
    if(!passport && hasTouched) {
      dispatch(updatePassport(null));
      setPassportError("This field is mandatory.");
      return false;
    }

    if(passport && !isValidPassport(passport.trim())) {
      setPassportError("Enter a valid passport number.");
      return false;
    } 

    // Timeout is to delay rendering if there is no error, 
    // which is to let click event on the Next button to be triggered first.
    setTimeout(()=>setPassportError(null), 100);
    return true;
  }

  const validate = () => {
    if (idType === ID_TYPE.NRIC_FIN) {
      return validateNricFin(true);
    } else if(idType === ID_TYPE.PASSPORT) {
      return validatePassport(true);
    }
    return false;
  }

  const idTypeChange= (idType) => {
    dispatch(updateIdType(idType));
    // clear errors
    if(idType === ID_TYPE.NRIC_FIN) {
      setPassportError(null);
    } else if(idType === ID_TYPE.PASSPORT) {
      setNricFinError(null);
    }
  }

  const onBlurNricFin = (hasTouched) => {
    if(validateNricFin(hasTouched)) {
      batch(()=>{
        dispatch(updateNricFin(nricFin.trim().toUpperCase()));
        dispatch(updatePassport(null));
      })
    }
  }

  const onBlurPassport= (hasTouched) => {
    if(validatePassport(hasTouched)) {
      batch(()=>{
        dispatch(updateNricFin(null));
        dispatch(updatePassport(passport.trim().toUpperCase()));
      });
    }
  }

  const clkNext = async () => {
    // ##AA
    const obj = document.querySelector("body");
    const event = new CustomEvent("event-view-end");
    obj.dispatchEvent(event);

    setLoading(true);
    if(loading) return;

    try {
      if(validate()) {
        if(idType === ID_TYPE.NRIC_FIN) {
          const hasApptResult = await hasAppointment(nricFin.trim().toUpperCase());
          console.log('hasAppt', hasApptResult);
          if(hasApptResult) {
            if(isLogin) {
              navigate(O2APPOINTMENT_INFO);
              return;
            } else {
              const {hasApptNricFin, hasApptPassport} = hasApptResult;
              batch(()=>{
                // respect the id type from response
                dispatch(nextIdentity({ idType: hasApptNricFin ? ID_TYPE.NRIC_FIN : ID_TYPE.PASSPORT, 
                  nricFin: hasApptNricFin, passport: hasApptPassport }));
                dispatch(updateHasAppt(hasApptResult));
              });
              navigate(O2WELCOME_BACK);
              return;
            }
          } else {
            // dispatch(nextIdentity({ idType, nricFin: nricFin.trim().toUpperCase(), passport: null }));
          }
        } else if(idType === ID_TYPE.PASSPORT) {
          const hasApptResult = await hasAppointment(passport.trim().toUpperCase());
          console.log('hasAppt', hasApptResult);
          if(hasApptResult) {
            if(isLogin) {
              navigate(O2APPOINTMENT_INFO);
              return;
            } else {
              const {hasApptNricFin, hasApptPassport} = hasApptResult;
              batch(()=>{
                // respect the id type from response
                dispatch(nextIdentity({ idType: hasApptNricFin ? ID_TYPE.NRIC_FIN : ID_TYPE.PASSPORT, 
                  nricFin: hasApptNricFin, passport: hasApptPassport }));
                dispatch(updateHasAppt(hasApptResult));
              });
              navigate(O2WELCOME_BACK);
              return;
            }
          } else {
            // dispatch(nextIdentity({ idType, nricFin: null, passport: passport.trim().toUpperCase() }));
          }
        }

        // Check if have appointment 
        navigate(O2APPOINTMENT_ENTRY);
      }
    } catch(e) {
      setLoading(false);
    }
  };

  // const onReCaptchaChange = (v) => {
  //   if(v) {
  //     console.log(v);
  //     // verifyCaptcha(v).then(res=>{
  //     //   console.log("verifyCaptcha", res);
  //     // });
  //   }
  // }

  let isNextDisabled = null;
  if(idType === ID_TYPE.NRIC_FIN) {
    isNextDisabled = !nrcFinFromStore || !isValidNric(nrcFinFromStore?.trim());
  } else if(idType === ID_TYPE.PASSPORT) {
    isNextDisabled = !passportFromStore || !isValidPassport(passportFromStore?.trim());
  }

  return (
    <Layout
      subHeader={"Book an appointment"}
      mainText={
        <div className={"section-header col-md-10 col-sm-10"}>
          <div className="title-container">
            <div className="title__text--overline  fs--default">CONTACT US</div>
            <h2 className="title__text title__text--semi-bold">Book an appointment</h2>
          </div>
        </div>
      }>
      <div>
        <div className="form-box--plain">
          <div className={"px-1 px-3 pb-3 pb-md-4 pt-64 md-pt-48 sm-pt-48"}>
            <h4 className={"text-center sm-mb-32 md-mb-32 lg-mb-48 xl-mb-48 lg-fs-32 xl-fs-32"}>Select identification type</h4>
            <div className="row justify-content-center pb-3">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                <div>
                  <div>Identification type</div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                <Radio
                  id="idType"
                  label={"Use NRIC or FIN number"}
                  value={ID_TYPE.NRIC_FIN}
                  checked={idType === ID_TYPE.NRIC_FIN}
                  onChange={()=>idTypeChange(ID_TYPE.NRIC_FIN)}
                  needCol={false}
                />
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                <Radio
                  id="idType"
                  label={
                    <>
                      <div>Use passport number</div>
                      <div className="second-row-caption">
                        Select this option only if you are not a Singapore Citizen or Permanent
                        Resident
                      </div>
                    </>
                  }
                  value={ID_TYPE.PASSPORT}
                  checked={idType === ID_TYPE.PASSPORT}
                  onChange={()=>idTypeChange(ID_TYPE.PASSPORT)}
                  needCol={false}
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                <Seperator />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "0px solid red" }}>
                {idType === ID_TYPE.NRIC_FIN && (
                  <InputText
                    label="NRIC or FIN number"
                    value={nricFin}
                    onChange={(e)=>setNricFin(e.target.value)}
                    isInvalid={nricFinError !== null}
                    errorMessage={nricFinError}
                    onBlur={onBlurNricFin}
                    footNote={"Already made a booking? Enter the NRIC or FIN of the person attending the appointment."}
                  />
                )}
                {idType === ID_TYPE.PASSPORT && (
                  <>
                    <InputText
                      label={
                        <>
                          <span>Passport number</span>
                          <Tooltip
                            text={
                              "Bookings made under a passport number can only be retrieved with the same passport number. You will not be able to view such bookings with your NRIC or FIN, or when signed in with Singpass."
                            }
                            style={{display: "inline-block"}}
                          />
                        </>
                      }
                      isInvalid={passportError !== null}
                      errorMessage={passportError}
                      onBlur={onBlurPassport}
                      value={passport}
                      onChange={(e)=>setPassport(e.target.value)}
                      footNote={"Already made a booking? Enter the passport number of the person attending the appointment."}
                      // isInvalid={validateErrors[MOBILE_INDEX]}
                      // errorMessage={validateErrors[MOBILE_INDEX]}
                    />
                  </>
                )}
                {/* <div className="input-caption">
                  Already made a booking? Enter the NRIC or FIN of the person attending the
                  appointment.
                </div> */}
              </div>
            </div>
          </div>
            {/* <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6" style={{ border: "1px solid red", display:"flex", justifyContent:"center" }}>
                <ReCAPTCHA
                  sitekey={window.reCaptchaSiteKey}
                  onChange={onReCaptchaChange}
                />     
              </div>
            </div> */}


          <div className="form-footer">
            {/*<div className={"flex--space-between"}>*/}
            <div
              className={
                "w-100 d-flex flex-column-reverse flex-md-row justify-content-between px-md-3 py-2 align-items-start "
              }>
              <div className={"mobile-w-100"}>
                <BackButton2 onClick={clkBack} />
              </div>
              <div className={"mb-3 mb-md-0 mobile-w-100"}>
                <NextButton2 disabled={isNextDisabled} onClick={clkNext} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
